import { Injectable, signal } from '@angular/core';

export interface RemainingTime {
  remainingTime: number;
  secondsToToday: number;
  minutesToToday: number;
  hoursToToday: number;
  daysToToday: number;
}

@Injectable()
export class DealCountdownService {
  private _remainingTime = signal<RemainingTime | null>(null);
  readonly remainingTime = this._remainingTime.asReadonly();

  getCountDown(endingTime: Date) {
    // set our end time
    const endTime = endingTime.getTime();

    // calculate remaining time from now until deadline
    function getRemainingTime(deadline: number): number {
      const currentTime = new Date().getTime();
      return deadline - currentTime;
    }

    // pad value with zero
    function pad(value: number): number {
      return Math.floor(value);
    }

    // show time repeatedly
    const showTime = () => {
      const remainingTime = getRemainingTime(endTime);
      const secondsToToday = pad((remainingTime / 1000) % 60);
      const minutesToToday = pad((remainingTime / (60 * 1000)) % 60);
      const hoursToToday = pad((remainingTime / (60 * 60 * 1000)) % 24);
      const daysToToday = pad(remainingTime / (24 * 60 * 60 * 1000));

      this._remainingTime.set({ remainingTime, secondsToToday, minutesToToday, hoursToToday, daysToToday });

      // ensure clock only updates if a second or more is remaining
      if (remainingTime >= 1000) {
        requestAnimationFrame(showTime);
      }
    }

    // kick it all off
    requestAnimationFrame(showTime);
  };
}
